import { rgba } from '@vimeo/bokeh-utils';
import { blue, green, red, yellow } from '../tokens/colors.js';
import { Button } from './button.js';
import { IconButton } from './iconButton.js';
import { Text } from './text.js';

const Alert = {
  parts: ["container", "title", "icon", "description", "closeButton"],
  baseStyle: {
    container: {
      ".chakra-toast &": {
        paddingRight: "20px",
        borderRadius: "0.1875rem",
        borderColor: "black",
        bgColor: "black",
        color: "white",
        _dark: {
          borderColor: "stroke",
          bgColor: "black"
        }
      },
      position: "relative",
      marginBottom: "1rem",
      borderRadius: "3px",
      color: "black",
      border: "1px solid",
      paddingY: "0.75rem",
      paddingX: "3rem",
      display: "flex",
      flexDirection: "column",
      gap: "0.65rem",
      alignItems: "flex-start",
      _dark: {
        color: "white"
      },
      "p:last-of-type": {
        maxWidth: "44rem"
      }
    },
    icon: {
      ".chakra-toast &": {
        top: "12px",
        color: "white",
        _dark: {
          color: "white"
        }
      },
      position: "absolute",
      top: "14px",
      left: "1rem",
      width: "20px",
      height: "20px"
    },
    title: {
      ".chakra-toast &": {
        ...Text.variants["paragraph-2"]
      },
      ...Text.variants["header-5"],
      paddingTop: "2px"
    },
    description: {
      ...Text.variants["paragraph-2"],
      marginTop: "0",
      paddingTop: "2px"
    },
    closeButton: {
      ...Button.variants?.minimal,
      ...IconButton.sizes?.xs,
      position: "absolute",
      top: ".25rem",
      right: ".25rem"
    }
  },
  variants: {
    info: {
      container: {
        borderColor: rgba(blue["500"], 0),
        bgColor: rgba(blue["500"], 0.15),
        _dark: {
          borderColor: rgba(blue["500"], 0.4),
          bgColor: rgba(blue["500"], 0.3)
        }
      },
      icon: {
        color: "blue.500"
      }
    },
    success: {
      container: {
        borderColor: rgba(green["500"], 0),
        bgColor: rgba(green["500"], 0.15),
        _dark: {
          borderColor: rgba(green["500"], 0.4),
          bgColor: rgba(green["500"], 0.3)
        }
      },
      icon: {
        color: "green.500"
      }
    },
    error: {
      container: {
        borderColor: rgba(red["500"], 0),
        bgColor: rgba(red["500"], 0.15),
        _dark: {
          borderColor: rgba(red["500"], 0.4),
          bgColor: rgba(red["500"], 0.3)
        }
      },
      icon: {
        color: "red.500"
      }
    },
    warning: {
      container: {
        borderColor: rgba(yellow["500"], 0),
        bgColor: rgba(yellow["500"], 0.15),
        _dark: {
          borderColor: rgba(yellow["500"], 0.4),
          bgColor: rgba(yellow["500"], 0.3)
        }
      },
      icon: {
        color: "yellow.500"
      }
    }
  },
  defaultProps: {
    variant: "info"
  }
};

export { Alert };
